import React, { useEffect, useState } from 'react';
import { useDarkMode } from './DarkModeContext';
import BrightnessLowIcon from '@material-ui/icons/BrightnessLow';
import Brightness2Icon from '@material-ui/icons/Brightness2';
import IconButton from '@material-ui/core/IconButton';


const ThemeToggle = ({className }) => {
    const { isDarkMode, setIsDarkMode } = useDarkMode();

    useEffect(() => {
        //// Apply the dark-mode class based on the theme state
        //if (isDarkMode) {
        //    document.body.classList.add('dark-mode');
        //    localStorage.setItem('theme', 'dark');
        //} else {
        //    document.body.classList.remove('dark-mode');
        //    localStorage.setItem('theme', 'light');

        console.log(isDarkMode);
    }, [isDarkMode]);

    const toggleTheme = () => {
        setIsDarkMode(!isDarkMode);
    };

    return (  
        <IconButton className={className} disableRipple={true} color="primary" onClick={toggleTheme} aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode" }>
            {isDarkMode ? <BrightnessLowIcon /> : <Brightness2Icon />}
        </IconButton>
    );
};

export default ThemeToggle;
